import {
  Box,
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  FormControlLabel,
  Grid,
  MenuItem,
  Paper,
  Tab,
  Tabs,
  TextField,
  Typography,
  Tooltip,
  Alert,
  DialogTitle,
  SelectChangeEvent,
  InputLabel,
  FormHelperText,
} from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import React, { useEffect, useLayoutEffect, useState } from 'react'
import { useSelector } from '../../redux/hooks/useSelector'
import { DEPOSIT_DIALOG_ID } from '../../constants/dialogConstants'
import { closeDialog } from '../../redux/actions/dialogActions'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import DatePicker from '@mui/lab/DatePicker'
import LocalizationProvider from '@mui/lab/LocalizationProvider'
import AdapterDateFns from '@date-io/date-fns'
import { Select, CircularProgress } from '@mui/material'
import { ToggleButton, ToggleButtonGroup } from '@mui/material'
import { useInputDialogColor } from '../../hooks/useInputDialogColor'
import { useClientApi } from '../../hooks/useClientApi'
import { Client, clients } from '../../redux/reducers/clients'
import { emptyClient } from '../../constants/initialStates'
import { AccountDeal } from '../../redux/reducers/portfolio'
import { setErrors } from '../../redux/actions/userActions'
import NumberFormat from 'react-number-format'
import { tokens } from '../../styles/tokens'
import { useCardHeaderStyles } from '../../styles/cards'

const useStyles = makeStyles(theme => ({
  DepositDialogHeader: {
    width: '100%',
    height: 60,
    display: 'flex',
    alignItems: 'center',
    background: `linear-gradient(135deg, ${tokens.color.primary[800]}, ${tokens.color.primary[600]})`,
    borderRadius: `${tokens.radius.lg} ${tokens.radius.lg} 0 0`,
    color: theme.palette.primary.contrastText,
    paddingLeft: theme.spacing(2),
    paddingBottom: theme.spacing(0.75),
    paddingRight: theme.spacing(2),
    justifyContent: 'center',
  },
  clientInformationDialog: {
    display: 'flex',
    flexDirection: 'row',
  },
  card: {
    borderRadius: tokens.radius.lg,
    boxShadow: tokens.shadow.sm,
    padding: theme.spacing(2),
    backgroundColor: tokens.color.neutral[50],
    width: '100%',
  },
  actionButtons: {
    width: '100%',
  },
  border: {
    border: `2px dashed ${theme.palette.grey[500]}`,
  },
}))


interface PropsDialog {
    setOpenConfirmation: (param: boolean) => any
    openConfirmationSave: boolean
    setOpenConfirmationSave: (param: boolean) => any
}

export const DepositDialog:React.FC = () => {
  const classes = useStyles()
  const cardHeader = useCardHeaderStyles()
  const { t } = useTranslation()
  const dialogs = useSelector(state => state.dialogs.dialogs)
  const accounts = useSelector(state => state.clients.accounts)
  const errors = useSelector(state => state.useractions.errors)
  const foundDialog = dialogs.find(dialog => dialog.id === 'DEPOSIT_DIALOG_ID')
  const open = !!foundDialog
  const dispatch = useDispatch()
  const handleClose = () => {
    dispatch(closeDialog(DEPOSIT_DIALOG_ID));
    setSelectedAccountId('')
    setAmount('')
    setDate(new Date())
    setType('BUY')
    setNote('')
    setSendNotification(true)
    dispatch(setErrors({}))
  }
  const [client, setClient] = useState<Client>(emptyClient)

  const [depositSent, setDepositSent] = useState(false)
  
  const onSubmitClick = () => {
    let payload: AccountDeal = {
      accountId: parseInt(selectedAccountId),
      tradeDate: date ? date.toISOString().slice(0, 10) : '',
      valueDate: date ? date.toISOString().slice(0, 10) : '',
      dealType: type,
      comment: note,
      amount: parseFloat(amount.replaceAll(/\s/g, '').replace(",", ".")),
      sendNotification: sendNotification
    }

    if (isValid(payload)) {
      handleSave(payload)
    }
    
  }

  const isValid = (payload: AccountDeal) => {
    let valid = true
    const errors: {
      [key: string]: boolean
    } = {}

    if (Number.isNaN(payload.accountId)) {
      valid = false
      errors['accountId'] = true
    }
      
    if (Number.isNaN(payload.amount)) {
      valid = false
      errors['amount'] = true
    }

    if (payload.tradeDate === '') {
      valid = false
      errors['date'] = true
    }

    dispatch(setErrors(errors))
    return valid
  }

  const handleSave = (payload: AccountDeal) => {
    setDepositSent(true)
    createAccountDeal(payload).finally(() => {
      setDepositSent(false)
    })
  }

  const [date, setDate] = useState<Date | null>(new Date())

  const handleDateChange = (newDate: Date | null) => {
    setDate(newDate)
  }

  type DealType = 'BUY' | 'SELL';

  const [type, setType] = useState<DealType>('BUY');

  const handleTypeChange = (event: React.MouseEvent<HTMLElement>, newType: DealType | null) => {
    if (newType !== null) {
      setType(newType);
    }
  }

  const [amount, setAmount] = useState<string>('');
  
  const handleAmountChange = (event: { target: { value: string } }) => {
    setAmount(event.target.value);
  }

  const { getClientAccounts, createAccountDeal } = useClientApi()

  useEffect(() => {
    // na mountu je client prazdny (clientId 0) - bez teto podminky posle
    // kazde otevreni stranky zbytecny dotaz /accounts/client/0, ktery konci 404
    if (client?.clientId) {
      getClientAccounts(client.clientId)
    }
  }, [client]);

  useEffect(() => {
      if (foundDialog?.payload.client) {
        setClient(foundDialog?.payload.client);
      }
    }, [foundDialog])

  const [selectedAccountId, setSelectedAccountId] = useState<string>('')

  const handleAccountChange = (event: SelectChangeEvent<string>) => {
    setSelectedAccountId(event.target.value);
  }

  const [sendNotification, setSendNotification] = useState<boolean>(true)

  const [note, setNote] = useState<string>('')

  const handleNoteChange = (event: SelectChangeEvent<string>) => {
    setNote(event.target.value)
  }

  const strategies = [
    'Apex ONE',
    'Apex SEMICONDUCTORS',
    'Apex ENERGY',
    'Apex GAMECHANGER',
    'Apex BLOCKCHAIN',
    'Apex TREASURY',
  ]

  return (
      <Dialog
        fullWidth
        maxWidth="md"
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title">
          <div className={classes.DepositDialogHeader}>
            <Typography variant="h5">{t('DEPOSIT_TO_ACCOUNT')}</Typography>
          </div>
          <DialogContent className={classes.clientInformationDialog}>
            <Paper className={classes.card}>
              <div className={cardHeader.header}>
                <p className={cardHeader.title}>{t('DEPOSIT_TO_ACCOUNT')}</p>
              </div>
              <Grid container spacing={1}>
              <Grid item xs={12}>
                <ToggleButtonGroup
                  exclusive
                  value={type}
                  onChange={handleTypeChange}
                  color="primary"
                  fullWidth
                >
                  <ToggleButton value="BUY">{t('DEPOSIT')}</ToggleButton>
                  <ToggleButton value="SELL">{t('WITHDRAWAL')}</ToggleButton>
                </ToggleButtonGroup>
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth required error={errors['accountId']}>
                  <InputLabel id="accountId-inputLabel">{t('ACCOUNT')}</InputLabel>
                  <Select
                    labelId="accountId-inputLabel"
                    id="accountId"
                    label="account-id"
                    value={selectedAccountId}
                    onChange={handleAccountChange}
                  >
                    {accounts.map((account) => (
                      <MenuItem key={account.accountId} value={account.accountId}>
                        {account.portfolioName + " - " + account.number + "_" + account.currency + "/" + account.bankCode}
                      </MenuItem>
                    ))}
                  </Select>                
                  <FormHelperText>{errors['accountId'] ? t('REQUIRE_ITEM') : ''}</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <NumberFormat
                  variant='standard'
                  fullWidth
                  required
                  id="amount"
                  label={t('FIGURE')}
                  helperText={errors['amount'] ? t('REQUIRE_ITEM') : ''}
                  error={errors['amount']}
                  value={amount}
                  onChange={handleAmountChange}
                  customInput={TextField}
                  thousandSeparator=" "
                  decimalSeparator=','
                  decimalScale={2}
                  allowNegative={false}
                />
              </Grid>
              <Grid item xs={12}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    renderInput={props => (
                      <TextField
                        id='tradeDate'
                        variant="standard"
                        fullWidth={true}
                        {...props}
                        label={t('DATE')}
                        helperText={errors['date'] ? t('REQUIRE_ITEM') : ''}
                        error={errors['date']}
                      />
                    )}
                    inputFormat="dd/MM/yyyy"
                    value={date}
                    onChange={handleDateChange}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <InputLabel id="strategy-label">{t('INVESTMENT_STRATEGY')}</InputLabel>
                  <Select
                    labelId="strategy-label"
                    id="strategy"
                    label="strategy"
                    value={note}
                    onChange={handleNoteChange}
                  >
                    <MenuItem value="">&nbsp;</MenuItem>
                    {strategies.map((s) => (
                      <MenuItem key={s} value={s}>{s}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={sendNotification}
                      onChange={(e) => setSendNotification(e.target.checked)}
                      color="primary"
                    />
                  }
                  label={t('SEND_NOTIFICATION')}
                />
              </Grid>
            </Grid>
            </Paper>
          </DialogContent>
          <DialogActions>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Button
                  className={classes.actionButtons}
                  size="large"
                  variant="contained"
                  color="primary"
                  onClick={handleClose}
                >
                  {t('CANCEL')}
                </Button>
              </Grid>
              <Grid item xs={6} position="relative">
                <Button 
                  className={classes.actionButtons} 
                  size="large" 
                  variant="contained" 
                  color="primary" 
                  disabled={depositSent}
                  onClick={onSubmitClick}
                >
                  {t('DONE')}
                </Button>
                {depositSent && (
                  <CircularProgress
                    size="1.4rem"
                      sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        marginTop: '-0.2rem',
                      }}
                  />)}
              </Grid>
            </Grid>
          </DialogActions>
      </Dialog>
  )
}

